import { Tabs } from "@mui/material";
import { useLocation } from "react-router-dom";
import { createUseStyles } from "$utils/createUseStyles";
import clsx from "clsx";
import { stringify } from "qs";
import { theme } from "$utils/theme/bataillog";

import useJStyles from "$hooks/useJStyles";

import { Layout, Paper, Tab, TabPanel } from "$components";
import useTabs from "$hooks/useTabs";
import { ShipmentTreatmentPanel } from "./treatmentTab";
import { ShippingRecordsTracking } from "./ShippingRecordsTracking";
import { useQueryParameters } from "$hooks/useQueryParameters";

function Shipments() {
  const { jclasses } = useJStyles();
  const classes = useStyles();

  const { currentTab, handleChangeTab } = useTabs();
  const urlParams = useQueryParameters();
  const location = useLocation();

  const handleUrlParams = (key: any, value: any) => {
    urlParams.set(key, value);
    const paramsToUrl = {};
    Array.from(urlParams.entries()).forEach(([key, value]) => {
      paramsToUrl[key] = value;
    });
    window.history.replaceState(
      null,
      "new page title",
      `${location.pathname}?${stringify(paramsToUrl)}`
    );
  };

  return (
    <div className={jclasses.jWrapper}>
      <Layout
        title="Liste des expéditions"
        contentClassName={jclasses.jLayoutCustom}
      >
        <Paper className={clsx(jclasses.jPaper, classes.stepContainer)}>
          <Tabs
            className={classes.tabHeader}
            TabIndicatorProps={{
              style: { background: theme.color.blueLight, height: 3 },
            }}
            value={currentTab}
            indicatorColor="primary"
            textColor="primary"
            onChange={handleChangeTab}
            aria-label="shipments tabs"
          >
            <Tab label="Traitement" />
            <Tab label="Suivi" />
          </Tabs>

          <>
            <TabPanel value={currentTab} index={0}>
              <ShipmentTreatmentPanel
                handleUrlParams={handleUrlParams}
                urlParams={urlParams}
              />
            </TabPanel>
            <TabPanel value={currentTab} index={1}>
              <ShippingRecordsTracking
                handleUrlParams={handleUrlParams}
                urlParams={urlParams}
              />
            </TabPanel>
          </>
        </Paper>
      </Layout>
    </div>
  );
}

export default Shipments;

const useStyles = createUseStyles(() => ({
  tabHeader: {
    borderBottom: `1px solid ${theme.color.gray2}`,
  },
  stepContainer: {
    display: "flex",
    flexDirection: "column",
    border: 10,
    padding: "4px 12px",
    marginBottom: 0,
  },
}));
